import WaydSectionSimple from "./WaydSectionSimple";

export default WaydSectionSimple;
